const { BUILD_ID_KEY, needsRelogin } = require('@/util/auth/buildSession');

module.exports = {
  isAuthenticated: (store) => async (to, from, next) => {
    const isAuthenticated = parseInt(localStorage.getItem('isAuthenticated'), 10) === 1;
    const hasTokens = !!(
      localStorage.getItem('mantraz_auth_token')
      || localStorage.getItem('mantraz_refresh_token')
    );

    // Deploy baru -> paksa login ulang sekali biar permission backend ke-refresh.
    if (needsRelogin({
      currentBuildId: process.env.VUE_APP_BUILD_ID,
      storedBuildId: localStorage.getItem(BUILD_ID_KEY),
      hasSession: isAuthenticated || hasTokens,
    })) {
      await store.dispatch('auth/logout');
      next({ path: '/auth/login', query: { reason: 'updated' } });
      return;
    }

    // Belum login dan tidak ada token utk recovery -> langsung ke login.
    if (!isAuthenticated && !hasTokens) {
      next('/auth/login');
      return;
    }

    // Skip fetch kalau user sudah di-load di session ini (navigasi antar route).
    // Tetap fetch kalau store kosong (page refresh atau first login).
    if (store.state.auth.userId) {
      next();
      return;
    }

    // Coba pulihkan sesi: getUser memicu /status, dan interceptor akan
    // auto-refresh kalau access token expired. Kalau refresh gagal,
    // interceptor sudah redirect ke /auth/login.
    try {
      await store.dispatch('auth/getUser');
      next();
    } catch (e) {
      next('/auth/login');
    }
  },
};
